import React from 'react';
import {observer, inject} from 'mobx-react';
import localeText from '@locale';
import store from '../Header/store';
import PortalMenu from '../PortalMenu';
import MenubarHeader from './MenubarHeader';

@inject((stores, props) => ({
  ...props,
  uiStore: store
}))
@observer
class MobileMenuBar extends React.Component {
  static defaultProps = {
    prefixClass: 'component-mobile-menubar'
  };

  render() {
    const {prefixClass, onClose} = this.props;
    return (
      <div className={prefixClass}>
        <MenubarHeader title={localeText('COMMON.TITLE_MENUBAR')} close={onClose} />
        <PortalMenu onClose={onClose} />
      </div>
    );
  }
}

export default MobileMenuBar;
